<template>
  <div class="own-brand-product">
    <Header
      class="yh-header"
      active="/ownBrandProduct"
      :product-value="productValue"
    />
    <div style="height: 75px" />
    <img
      src="@/assets/ownBrandProduct/brand1.jpg"
      alt=""
      class="top-img"
    >
    <div class="brand-main">
      <img
        src="@/assets/ownBrandProduct/brand2.png"
        alt=""
      >
      <div class="brand">
        <div
          v-for="(item,i) in brandList"
          :key="i"
          @mouseover="handleCheck(item.url,item.short)"
          @click="handleLookDetails"
        />
      </div>
    </div>
    <img
      :src="brandUrl"
      alt=""
      class="brand-img"
      @click="handleLookDetails"
    >
    <img
      src="@/assets/ownBrandProduct/brand3.jpg"
      alt=""
    >
    <img
      src="@/assets/ownBrandProduct/brand4.jpg"
      alt=""
    >
    <img
      src="@/assets/ownBrandProduct/brand5.jpg"
      alt=""
    >
  </div>
</template>
<script>
import Header from '@/components/Header'
export default {
  name: 'OwnBrandProduct',
  components: {
    Header
  },
  data() {
    return {
      productValue: this.util.getVariantSession('tagId'),
      brandList: [
        {
          label: '永辉农场',
          short: 'yhnc',
          url: require('@/assets/ownBrandProduct/yhnc.png')
        },
        {
          label: '田趣',
          short: 'tq',
          url: require('@/assets/ownBrandProduct/tq.png')
        },
        {
          label: '馋大狮',
          short: 'cds',
          url: require('@/assets/ownBrandProduct/cds.png')
        },
        {
          label: '优颂',
          short: 'ys',
          url: require('@/assets/ownBrandProduct/ys.png')
        },
        {
          label: 'ofresh',
          short: 'ofresh',
          url: require('@/assets/ownBrandProduct/ofresh.png')
        }
      ],
      brandUrl: require('@/assets/ownBrandProduct/yhnc.png'), // 品牌图像
      type: 'yhnc'  // 品牌类型
    }
  },
  methods: {
    handleCheck(url, type) {
      this.brandUrl = url
      this.type = type
    },
    // 查看详情
    handleLookDetails() {
      window.open(`/ownBrandProduct/detail/${this.type}`)
    }
  }
}
</script>

<style lang="less">
.own-brand-product {
  background: #F9FFDD;
  img {
    display: block;
    width: 100%;
  }
  .top-img{
    margin-top: -85px;
  }
  .brand-main{
    position: relative;
    width: 650px;
    height: 144px;
    margin: 0 auto;
    .brand{
      width: 650px;
      height: 90px;
      position: absolute;
      left: 0;
      top: 55px;
      display: flex;
      justify-content: space-between;
      >div{
        width: 80px;
        height: 100%;
        cursor: pointer;
      }
    }
  }
  .brand-img{
    width: 658px;
    margin:1px auto 50px;
    cursor: pointer;
  }
}
</style>
